import { createContext, useContext, useState } from "react";

const FormContext = createContext();

const initialFormData = {
  personalInformation: {
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    whatsAppNumber: "",
    dateOfBirth: "",
    gender: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    civilIdNumber: "",
    idExpireDate: "",
    photoProof: null,
    civilIdImage: null,
  },
  emergencyDetails: {
    emergencyContactFirstName: "",
    emergencyContactLastName: "",
    emergencyContactRelationship: "",
    emergencyContactPhoneNumber: "",
  },
  medicalInformation: {
    bloodGroup: "",
    medicalConditions: "",
    medicalConditionDetails: "",
  },
  membership: {
    membershipType: "",
    preferredStartDate: "",
  },
};

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState(initialFormData);

  const resetFormData = () => {
    setFormData(initialFormData);
  };

  return (
    <FormContext.Provider value={{ formData, setFormData, resetFormData }}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormData = () => useContext(FormContext);
